import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { footerUpdate } from '../../modules/editor';
import { RootState } from '../../modules';
import Alert from '../../lib/Alert';

type Props = {
	selectedContentId: number;
	currentContent: any;
}


function SelectedContentFooter({ selectedContentId, currentContent }: Props) {
	const { listId, isListDeleted } = useSelector((state: RootState) => state.editor.email);
	const hasNoList = listId === -1 || listId === undefined || isListDeleted;
	const msg = useSelector((state: RootState) => state.editor.service.msg);
	
	const dispatch = useDispatch();

	const requertListInfo = (e:any) => {
		if (hasNoList) {
			Alert.error(msg.CHECK_SELECT_LISTS);
			return;
		}
		e.stopPropagation();
		dispatch(footerUpdate(selectedContentId));
	}

	return (
		<div className="editor-sidebar-selected-content-setting">
			<div className="description">
				<h1>
					이렇게 사용하세요.
				</h1>
				<p>
					푸터 상자를 추가하면 주소록을 만들 때 이메일 푸터 정보와 수신거부 링크가 자동으로 입력됩니다. <br /><br />
					입력된 내용은 자유롭게 수정할 수 있습니다. 푸터 상자 추가 후 표시된 내용은 자유롭게 수정할 수 있습니다.					
				</p>
			</div>
			<div className="field-section">
				<div className="footer-field">
					<p>
						이메일 푸터 정보를 다시 불러옵니다. 텍스트 스타일도 모두 초기화됩니다.
					</p>
					<button 
						className="btn small"
						onClick={requertListInfo}
					>
						다시 불러오기
					</button>
				</div>
			</div>
		</div>
	);
}

export default SelectedContentFooter;